function extractDate(encryptedString) {
  return `${encryptedString.split("/")[0]}/${encryptedString.split("/")[1]}`;
}

export default extractDate;